import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from '../Utils';

// Workflows
function pathViewWorkflowEditor(workflowId=null) {
  if (workflowId) {
      return `view/workflow-editor/${workflowId}`;
  } else {
      return `view/workflow-editor`;
  }
}

export function getViewWorkflowEditor(successCallback, errorCallback, workflowId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewWorkflowEditor(workflowId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageWorkflows(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-workflows`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathWorkflows(workflowId=null) {
  if (workflowId) {
      return `workflows/${workflowId}`;
  } else {
      return `workflows`;
  }
}

export function createWorkflows(successCallback, errorCallback, data) {
  postAuth({
    "path": pathWorkflows(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchWorkflows(successCallback, errorCallback, data, workflowId) {
  patchAuth({
    "path": pathWorkflows(workflowId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteWorkflows(successCallback, errorCallback, workflowId) {
  deleteAuth({
    "path": pathWorkflows(workflowId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Members
export function getViewManageWorkflowMembers(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-workflow-members`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathWorkflowMembers(memberId=null) {
  if (memberId) {
      return `workflow-members/${memberId}`;
  } else {
      return `workflow-members`;
  }
}


export function deleteWorkflowMembers(successCallback, errorCallback, memberId) {
  deleteAuth({
    "path": pathWorkflowMembers(memberId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postExitMembers(successCallback, errorCallback, memberId) {
  postAuth({
    "path": `workflow-members/${memberId}/exit`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Logs
export function getViewManageWorkflowLogs(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-workflow-logs`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Conversions
export function getViewManageWorkflowConversions(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-workflow-conversions`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Analytics
export function getViewWorkflowAnalytics(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/workflow-analytics`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

// Exclusions
function pathWorkflowExclusions(exclusionId=null) {
  if (exclusionId) {
      return `workflow-exclusions/${exclusionId}`;
  } else {
      return `workflow-exclusions`;
  }
}

export function createWorkflowExclusions(successCallback, errorCallback, data) {
  postAuth({
    "path": pathWorkflowExclusions(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteWorkflowExclusions(successCallback, errorCallback, exclusionId) {
  deleteAuth({
    "path": pathWorkflowExclusions(exclusionId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function urlUploadWorkflowExclusions(workflowId) {
  return `/${constants.API_VERSION}/workflows/${workflowId}/upload-exclusions`;
}

export function getViewManageWorkflowExclusions(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-workflow-exclusions`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

// Playbooks
export function getViewManageWorkflowPlaybooks(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-workflow-playbooks`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}
